export const fallbackArray = (arr: any[] | undefined, defaultArr: any[]): any[] => {
    if (!arr || arr.length === 0) {
        return defaultArr;
    }

    return arr;
};
